import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=7b3f4fb5&scoped=true&"
import script from "./ProductDetail.vue?vue&type=script&lang=js&"
export * from "./ProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=7b3f4fb5&scoped=true&lang=css&"
import style1 from "./ProductDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3f4fb5",
  null
  
)

export default component.exports